<div fxLayout="column">
	<div fxLayout="row" [fxLayoutAlign]="float ? 'end center' : 'center center'">
		<div fxLayout="column" fxLayoutAlign="space-around center" [ngClass]="{'logo-container': float}">
			<div>
				<img class="eu-logo" src="assets/images/eu_logo.svg"/>
			</div>
			<p>Este proyecto está financiado por la Unión Europea</p>
		</div>
	</div>
</div>
